import {
  CATADVS_GET_ARTICLES_REQUEST,
  CATADVS_GET_ARTICLES_SUCCESS,
  CATADVS_GET_ARTICLES_FAIL,
  CATADVS_GET_CATEGORIES_REQUEST,
  CATADVS_GET_CATEGORIES_SUCCESS,
  CATADVS_GET_CATEGORIES_FAIL,
  CATADVS_REMOVE_ARTICLE_REQUEST,
  CATADVS_REMOVE_ARTICLE_SUCCESS,
  CATADVS_REMOVE_ARTICLE_FAIL,
  CATADVS_GET_ARTICLE_REQUEST,
  CATADVS_GET_ARTICLE_SUCCESS,
  CATADVS_GET_ARTICLE_FAIL,
  CATADVS_AUDIT_ARTICLE_REQUEST,
  CATADVS_AUDIT_ARTICLE_SUCCESS,
  CATADVS_AUDIT_ARTICLE_FAIL,
  CATADVS_EDIT_ARTICLE_REQUEST,
  CATADVS_EDIT_ARTICLE_SUCCESS,
  CATADVS_EDIT_ARTICLE_FAIL,
  CATADVS_QUOTE_ARTICLE_REQUEST,
  CATADVS_QUOTE_ARTICLE_SUCCESS,
  CATADVS_QUOTE_ARTICLE_FAIL,
  CATADVS_CREATE_ARTICLE_REQUEST,
  CATADVS_CREATE_ARTICLE_SUCCESS,
  CATADVS_CREATE_ARTICLE_FAIL,
  CATADVS_PAY_ARTICLE_REQUEST,
  CATADVS_PAY_ARTICLE_SUCCESS,
  CATADVS_PAY_ARTICLE_FAIL
} from "../actions/catadvs";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},
  editArticleRequest: false,
  successBackMsg: "",
  quoteMsg: "",
  beginTime: "",
  errorQuoteMsg: ''
};

const catadvs = (state = initialState, action) => {
  switch (action.type) {
    case CATADVS_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case CATADVS_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          articles: action.data.data,
          articlesPagination: {
            currentPage: action.data.current_page,
            lastPage: action.data.last_page
          },
          quoteMsg: ""
      };
    case CATADVS_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case CATADVS_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case CATADVS_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          categories: action.data
      };
    case CATADVS_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case CATADVS_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case CATADVS_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          selectedArticle: {},
          quoteMsg: ""
      };
    case CATADVS_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors,
          selectedArticle: {}
      };
    case CATADVS_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
          successBackMsg: "",
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case CATADVS_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: action.data,
          quoteMsg: ""
      };
    case CATADVS_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
          selectedArticle: {}
      };
    case CATADVS_AUDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case CATADVS_AUDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case CATADVS_AUDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };
    case CATADVS_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case CATADVS_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case CATADVS_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };
    case CATADVS_QUOTE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          quoteMsg: "",
          errorQuoteMsg: "",
          errors: {}
      };
    case CATADVS_QUOTE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          quoteMsg: action.msg,
          errorQuoteMsg: "",
          beginTime: action.data,
          errors: {}
      };
    case CATADVS_QUOTE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          quoteMsg: "",
          errorQuoteMsg: action.msg,
          errors: action.errors
      };
    case CATADVS_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case CATADVS_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case CATADVS_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };
    case CATADVS_PAY_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {}
      };
    case CATADVS_PAY_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {}
      };
    case CATADVS_PAY_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors
      };

    default:
      return state;
  }
};

export default catadvs;